/* CM Beauty — colecții: filtre și sortare fără reîncărcare, sertar de filtre pe mobil, „Încarcă mai multe”, adăugare rapidă. */
(() => {
  if (window.cmCollectionReady) return;
  window.cmCollectionReady = true;

  const root = () => document.querySelector('[data-cmc-root]');
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
  let controller = null;

  /* ---------- Sertar filtre ---------- */
  const setDrawer = (open) => {
    const r = root();
    if (!r) return;
    const drawer = r.querySelector('[data-cmc-drawer]');
    const scrim = r.querySelector('.cmc-scrim');
    const btn = r.querySelector('[data-cmc-open]');
    drawer.classList.toggle('is-open', open);
    if (scrim) scrim.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('cmc-lock', open && isMobile());
  };

  /* ---------- Reîncărcare secțiune ---------- */
  const render = async (url, { push = true, keepDrawer = false } = {}) => {
    const r = root();
    if (!r) return (window.location.href = url);
    const sectionId = r.dataset.sectionId;
    const drawerOpen = keepDrawer && r.querySelector('[data-cmc-drawer]').classList.contains('is-open');
    const drawerScroll = r.querySelector('[data-cmc-drawer]').scrollTop;

    if (controller) controller.abort();
    controller = new AbortController();
    r.classList.add('is-loading');
    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);
      const res = await fetch(target, { signal: controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-cmc-root]');
      if (!next) throw new Error('no section');
      r.innerHTML = next.innerHTML;
      renderRecent();
      if (push) history.pushState({ cmc: true }, '', url);
      if (drawerOpen) {
        setDrawer(true);
        r.querySelector('[data-cmc-drawer]').scrollTop = drawerScroll;
      } else {
        document.documentElement.classList.remove('cmc-lock');
      }
      if (!keepDrawer) {
        const bar = r.querySelector('.cmc-bar');
        if (bar && bar.getBoundingClientRect().top < 0) bar.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    } catch (e) {
      if (e.name !== 'AbortError') window.location.href = url;
    } finally {
      const cur = root();
      if (cur) cur.classList.remove('is-loading');
    }
  };

  const formUrl = (form) => {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (String(v).trim() !== '') params.append(k, v);
    const qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  };

  /* ---------- Văzute recent (salvate în acest browser când se deschide un produs din listă) ---------- */
  const RECENT_KEY = 'cmc-recent';
  const readRecent = () => {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };
  const remember = (card) => {
    const raw = card && card.dataset.cmcP;
    if (!raw) return;
    const url = raw.split('|')[0];
    const list = readRecent().filter((item) => item.split('|')[0] !== url);
    list.unshift(raw);
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {
      /* fără localStorage */
    }
  };
  const renderRecent = () => {
    const r = root();
    const box = r && r.querySelector('[data-cmc-recent]');
    if (!box) return;
    const items = readRecent().slice(0, 8);
    if (!items.length) return;
    const ul = box.querySelector('[data-cmc-recent-list]');
    ul.innerHTML = '';
    items.forEach((raw) => {
      const [url, title, img] = raw.split('|');
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'cmc-recent__item';
      a.href = url;
      if (img) {
        const pic = document.createElement('img');
        pic.src = img;
        pic.alt = '';
        pic.loading = 'lazy';
        a.appendChild(pic);
      }
      const span = document.createElement('span');
      span.textContent = title;
      a.appendChild(span);
      li.appendChild(a);
      ul.appendChild(li);
    });
    box.hidden = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderRecent);
  else renderRecent();

  /* ---------- Evenimente ---------- */
  document.addEventListener('change', (event) => {
    const r = root();
    if (!r || !r.contains(event.target)) return;

    if (event.target.matches('[data-cmc-sort]')) {
      const form = r.querySelector('[data-cmc-form]');
      form.querySelector('[data-cmc-sort-hidden]').value = event.target.value;
      render(formUrl(form));
      return;
    }
    const form = event.target.closest('[data-cmc-form]');
    if (form) render(formUrl(form), { keepDrawer: true });
  });

  // Prețul se aplică la Enter sau la ieșirea din câmp (evenimentul change) — Enter nu trimite formularul clasic
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cmc-form]');
    if (!form) return;
    event.preventDefault();
    render(formUrl(form), { keepDrawer: true });
  });

  document.addEventListener('click', async (event) => {
    const t = event.target;
    const r = root();

    if (t.closest('[data-cmc-open]')) return setDrawer(true);
    if (t.closest('[data-cmc-close]')) return setDrawer(false);

    const more = t.closest('[data-cmc-more-opts]');
    if (more) {
      const list = more.previousElementSibling;
      list.classList.toggle('is-expanded');
      more.textContent = list.classList.contains('is-expanded') ? 'Arată mai puține' : more.dataset.label || more.textContent;
      return;
    }

    const cardLink = t.closest('.cmc-card a');
    if (cardLink) remember(cardLink.closest('.cmc-card'));

    const link = t.closest('a[data-cmc-link]');
    if (link && r && r.contains(link)) {
      event.preventDefault();
      render(link.href, { keepDrawer: !!link.closest('[data-cmc-drawer]') });
      return;
    }

    // Încarcă mai multe: adaugă pagina următoare sub cea curentă
    const loadMore = t.closest('[data-cmc-load-more]');
    if (loadMore && r) {
      event.preventDefault();
      if (loadMore.getAttribute('aria-busy') === 'true') return;
      loadMore.setAttribute('aria-busy', 'true');
      loadMore.textContent = 'Se încarcă…';
      try {
        const target = new URL(loadMore.href, window.location.origin);
        target.searchParams.set('section_id', r.dataset.sectionId);
        const html = await (await fetch(target)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = r.querySelector('[data-cmc-grid]');
        doc.querySelectorAll('[data-cmc-grid] [data-cmc-item]').forEach((li) => grid.appendChild(li));
        const pager = r.querySelector('[data-cmc-pager]');
        const nextPager = doc.querySelector('[data-cmc-pager]');
        if (pager && nextPager) {
          pager.innerHTML = nextPager.innerHTML;
          const prev = pager.querySelector('.cmc-pager__prev');
          if (prev) prev.remove();
        }
        history.replaceState({ cmc: true }, '', loadMore.href);
      } catch (e) {
        window.location.href = loadMore.href;
      }
      return;
    }

    // Adaugă rapid în coș
    const add = t.closest('[data-cmc-add]');
    if (add) {
      event.preventDefault();
      if (add.disabled) return;
      const label = add.querySelector('span');
      const original = label ? label.textContent : '';
      const sections = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      add.disabled = true;
      add.classList.add('is-busy');
      try {
        const res = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(add.dataset.cmcAdd), quantity: 1 }], sections: sections.join(',') }),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'Eroare');
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: {}, sourceId: 'cm-collection', data: { source: 'cm-collection', itemCount: 1, sections: data.sections } },
          })
        );
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
        else if (!drawer) window.location.href = base + 'cart';
        add.classList.add('is-done');
        if (label) label.textContent = 'Adăugat';
      } catch (e) {
        if (label) label.textContent = 'Indisponibil';
      } finally {
        add.disabled = false;
        add.classList.remove('is-busy');
        setTimeout(() => {
          add.classList.remove('is-done');
          if (label) label.textContent = original;
        }, 2200);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setDrawer(false);
  });

  window.addEventListener('popstate', () => {
    if (root()) render(window.location.href, { push: false });
  });
})();
